export var MAXIMIZED_LABEL_FONT_SIZE = 14;
export var MINIMIZED_LABEL_FONT_SIZE = 12;
export var LABEL_WIGGLE_X_OFFSET = 4;
export var LABEL_PADDING_HORIZONTAL = 12;